/**
 * WaveboxSuggestionChip hook.
 *
 * Mounted on the chip that suggests switching engines (either direction:
 * general → Chat with Settings, or the settings assistant → general model).
 * While mounted, watches the compose-box contenteditable for typing activity.
 * Once the user has typed `threshold` characters, auto-dismisses the chip by
 * pushing the server event named in `data-dismiss-event` (defaulting to
 * `dismiss_wavebox_suggestion` for backward compatibility).
 *
 * The threshold resets each time the chip mounts, so behaviour is:
 *   chip appears with compose empty → user types 5 chars → chip dismissed.
 *   chip appears with compose already containing text → user types 5 more
 *     chars after mount → chip dismissed.
 */
const THRESHOLD = 5

export default {
  mounted () {
    this.composeInput = document.getElementById('message-input')

    if (!this.composeInput) {
      return
    }

    this.startingLength = (this.composeInput.textContent || '').length
    this.dismissed = false
    this.dismissEvent = this.el.dataset.dismissEvent || 'dismiss_wavebox_suggestion'

    this.handleInput = () => {
      if (this.dismissed) {return}

      const currentLength = (this.composeInput.textContent || '').length
      const typed = currentLength - this.startingLength

      if (typed >= THRESHOLD) {
        this.dismissed = true
        this.pushEvent(this.dismissEvent, {})
      }
    }

    this.composeInput.addEventListener('input', this.handleInput)
  },

  destroyed () {
    if (this.composeInput && this.handleInput) {
      this.composeInput.removeEventListener('input', this.handleInput)
    }
  }
}
